import Vue from "vue";
import Router from "vue-router";
import Login from "@/views/Login.vue";
import Home from "@/views/home.vue";
import { asyncRoutes } from "./asyncRoutes";

Vue.use(Router);

const constantRoutes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { title: "登录" },
  },
  {
    path: "/black",
    meta: { title: "点击同一路由刷新当前路由" },
    component: () => import("../views/black.vue"),
  },
];

const router = new Router({
  mode: "history",
  routes: constantRoutes,
});

const whiteList = ["/login"];

function getUserPermissions() {
  const permissionsStr = sessionStorage.getItem("permissions");
  if (!permissionsStr) {
    return [];
  }

  try {
    return JSON.parse(permissionsStr) || [];
  } catch (error) {
    console.error("解析权限信息失败", error);
    return [];
  }
}

function filterAsyncRoutes(routes, permissions) {
  const res = [];
  routes.forEach((route) => {
    let filteredChildren = [];
    if (route.children && route.children.length) {
      filteredChildren = filterAsyncRoutes(route.children, permissions);
    }

    const routePermission = route.meta?.permission;
    const hasSelfPermission = routePermission
      ? permissions.includes(routePermission)
      : true;

    if (hasSelfPermission || filteredChildren.length > 0) {
      const tmp = { ...route };
      if (filteredChildren.length > 0) {
        tmp.children = filteredChildren;
      } else {
        delete tmp.children;
      }
      res.push(tmp);
    }
  });
  return res;
}

let filteredAsyncRoutes = [];
let dynamicRoutesAdded = false;

function addDynamicRoutes(permissions) {
  if (dynamicRoutesAdded) {
    return;
  }

  filteredAsyncRoutes = filterAsyncRoutes(asyncRoutes, permissions);
  window._filteredAsyncRoutes = filteredAsyncRoutes;

  try {
    router.addRoutes([
      {
        path: "/home",
        name: "home",
        component: Home,
        redirect: "/home/dashboard",
        meta: { title: "首页" },
        children: [
          {
            path: "dashboard",
            name: "dashboard",
            component: () => import("@/views/dashboard/dashboard.vue"),
            meta: { title: "数据统计", icon: "el-icon-s-home", menu: true },
          },
          ...filteredAsyncRoutes,
        ],
      },
      {
        path: "*",
        redirect: "/login",
      },
    ]);
    dynamicRoutesAdded = true;
  } catch (error) {
    console.error("动态路由注册失败", error);
  }
}

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem("access_token");
  if (!token) {
    if (whiteList.includes(to.path)) {
      next();
    } else {
      next("/login");
    }
    return;
  }

  if (to.path === "/login") {
    next({ path: "/home", replace: true });
    return;
  }

  const permissions = getUserPermissions();
  if (!permissions.length) {
    sessionStorage.clear();
    if (to.path !== "/login") {
      next("/login");
    } else {
      next();
    }
    return;
  }

  const willAddDynamicRoutes = !dynamicRoutesAdded;
  addDynamicRoutes(permissions);

  const leafRoute = to.matched[to.matched.length - 1];
  const leafPermission = leafRoute && leafRoute.meta?.permission;
  if (leafPermission && !permissions.includes(leafPermission)) {
    next({ path: "/home", replace: true });
    return;
  }

  if (to.matched && to.matched.length > 0) {
    next();
  } else if (willAddDynamicRoutes) {
    // 重新触发一次当前路径匹配，确保刚刚注册的动态路由生效
    next({ path: to.fullPath, replace: true });
  } else {
    next({ path: "/home", replace: true });
  }
});

export default router;
